module.exports = __webpack_public_path__ + "img/ic_logo_weidian@2x.94ee3f92.png";